export default __webpack_public_path__ + "static/media/cs_icon_07.ff411168.png";